/*
 * @Description: file content
 * @Author: ywl
 * @Date: 2021-03-05 09:42:51
 * @LastEditors: ywl
 * @LastEditTime: 2021-03-27 14:25:38
 */
import axios from 'axios';
import store from '../store/index';
import router from '../router/index';
import { Message } from 'element-ui';
import { Tool } from '@/utils/tool'; // 假设有一个生成nonce和签名的方法
const tools = new Tool();
console.log(tools);
const instance = axios.create({
  baseURL: process.env.VUE_APP_AI_API, // 配置接口地址
  timeout: 600000,
  withCredentials: false,
});
// instance.defaults.onDownloadProgress = function (progressEvent) {
//   // downloadProgress(progressEvent)
// }
const token = 'token';

// 请求拦截
instance.interceptors.request.use(
  (config) => {
    // 一般使用这里来设置请求头里面带token
    if (store.getters['user/isLogin']()) {
      config.headers[token] = store.getters['user/getToken']();
    }
    // 添加自定义header
    const timestamp = new Date().getTime();
    const nonce = tools.getNonce(16);
    config.headers['X-Timestamp'] = timestamp;
    config.headers['X-Nonce'] = nonce;
    config.headers['x-Signature'] = tools.ShaGeneratesignature(timestamp, nonce); // 假设有一个生成签名的方法
    return config;
  },
  (err) => Promise.reject(err)
);

// 响应拦截
instance.interceptors.response.use(
  (response) => {
    console.log('response', response);
    if (response.status === 200) {
      // 处理code=200的业务 代表请求成功
      return Promise.resolve(response.data);
    } else {
      // 处理code非200的业务 代表请求失败
      if (response.status === 401) {
        store.dispatch('user/logout').then(() => {
          router.push('/login');
        });
        Message.error(response.data.resultMsg || 'token失效');
        return Promise.reject(response.data.message);
      } else {
        Message.error(response.data.resultMsg || '系统处理出错');
        return Promise.reject(response.data);
      }
    }
  },
  (err) => Promise.reject(err)
);

export default instance;
